import { render, staticRenderFns } from "./AnaLayoutInvitation.vue?vue&type=template&id=4368d2da&scoped=true&"
import script from "./AnaLayoutInvitation.vue?vue&type=script&lang=js&"
export * from "./AnaLayoutInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AnaLayoutInvitation.vue?vue&type=style&index=0&id=4368d2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368d2da",
  null
  
)

export default component.exports